import React, { useEffect, useState } from "react";
import "./Free_Consultation.css";
import Common_Btn from "../../common/common-btn/Common_Btn";
import Solar_Modal from "../../common/solar-modal/Solar_Modal";
import { useNavigate } from "react-router-dom";

const Free_Consultation = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate =useNavigate();

  // useEffect(() => {
  //   if (showModal) {
  //     const timer = setTimeout(() => {
  //       setShowModal(false);
  //       navigate("/");
  //     }, 2500); 

  //     return () => clearTimeout(timer);
  //   }
  // }, [showModal]);


  return (
    <section className="Free_Consultation">
      <div className="container">
        <div className="Free_Consultation_div">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-5">
              <div className="Free_Consultation_img_holder">
                <img
                  src="/assets/images/home/free_consultation/img-1.png"
                  alt="consultant"
                  className="Free_Consultation_img"
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="Free_Consultation_text_div">
                <h5 className="Free_Consultation_header">
                  Book Your <span>Free Solar Consultation</span> Today
                </h5>

                <p className="Free_Consultation_text">
                  Discover how much you can save with a customized solar plan
                  for your home or business.
                </p>

                <div
                  className="free_btn_holder"
                  onClick={() => setShowModal(true)}
                >
                  <Common_Btn text={"Get Free Consultation"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Solar_Modal show={showModal} handleClose={() => setShowModal(false)} />
    </section>
  );
};

export default Free_Consultation;
